

























import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";
import PickerDialogComponent from "@/components/common/PickerDialog.vue";
import { NoteChange, ProjectNote } from "@/data/models/ProjectNote";
import { ProjectDetails } from "@/data/models/ProjectDetails";
import { formatContactPerson } from "@/utils/LocalisationHelper";
import { generateRandomUuid } from "@/utils/Utils";
import { updateNote } from "@/data/repository/ProjectNotesRepository";
import { getRecordInfo } from "@/data/repository/UserRepository";

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
    picker: PickerDialogComponent,
  },
})
export default class ProjectNoteFormComponent extends Vue {
  @Prop()
  projectDetails!: ProjectDetails;

  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  noteText = "";
  selectedContactPerson = 0;

  newNote = true;
  noteId = "";

  get contactPersonOptions() {
    return [
      0,
      ...this.projectDetails.clientData.contactPersons.map(
        (contactPerson) => contactPerson.contactPersonNumber
      ),
    ];
  }

  get contactPersonFormatter() {
    return (contactPersonNumber: number) => {
      const contactPerson = this.projectDetails.clientData.contactPersons.find(
        (contactPerson) =>
          contactPerson.contactPersonNumber === contactPersonNumber
      );

      return formatContactPerson(this, contactPersonNumber, contactPerson);
    };
  }

  resolve?: (value: boolean) => void = undefined;
  reject?: (reason: string) => void = undefined;

  async show(projectNote: ProjectNote | null) {
    if (projectNote) {
      this.newNote = false;
      this.noteId = projectNote.id;
      this.noteText = projectNote.note ?? "";
    } else {
      this.newNote = true;
      this.noteId = generateRandomUuid();
      this.noteText = "";
    }

    this.baseDialogComponent.show({
      styleAsAlertDialog: true,
      title: this.$t(
        `projectDetails.${projectNote ? "updateNote" : "createNote"}`
      ).toString(),
      negativeButtonText: this.$t("common.abort").toString(),
      neutralButtonText: this.newNote
        ? undefined
        : this.$t("common.delete").toString(),
      persistent: false,
    });

    return new Promise<boolean>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  async onSave() {
    const contatctPersonId =
      this.projectDetails.clientData.contactPersons.find(
        (contactPerson) =>
          contactPerson.contactPersonNumber == this.selectedContactPerson
      )?.id ?? null;

    const noteUpdate = {
      id: this.noteId,
      createdBy: getRecordInfo(),
      useForReport: false,
      event: "NOTE",
      note: this.noteText,
      targetApartment: {
        contactPersonId: contatctPersonId,
      },
      recipients: [
        {
          recipient: "99999",
          read: false,
        },
      ],
    };

    return await updateNote(
      noteUpdate,
      this.projectDetails.id,
      this.noteId,
      this.newNote ? NoteChange.CREATED : NoteChange.UPDATED,
      this.projectDetails.syncTarget
    );
  }

  async onDeleteNote() {
    return await updateNote(
      null,
      this.projectDetails.id,
      this.noteId,
      NoteChange.DELETED,
      this.projectDetails.syncTarget
    );
  }
}
